import clsx from 'clsx';
import styles from './Stepper.module.css';

interface Props {
  current: number; // 1-based
  total: number;
  labels: string[];
}

export const Stepper = ({ current, total, labels }: Props) => (
  <div className={styles.wrap}>
    <div className={styles.bar}>
      {Array.from({ length: total }).map((_, i) => (
        <div
          key={i}
          className={clsx(
            styles.segment,
            i + 1 < current && styles.segmentDone,
            i + 1 === current && styles.segmentActive,
          )}
        />
      ))}
    </div>
    <div className={styles.meta}>
      <span className={styles.metaCounter}>
        Шаг {current} из {total}
      </span>
      <span className={styles.metaLabel}>{labels[current - 1]}</span>
    </div>
  </div>
);